import isEqual from 'lodash/isEqual';
import React from 'react';
import PropTypes from 'prop-types';
import renderSanitizedHtml from './renderSanitizedHtml';

/**
 * @typedef {object} HighlighterProps
 * @property {string} [className]
 * @property {string} [text]
 * @property {string | string[]} [highlight]
 * @property {string} [type]
 */

/** @type {React.FC<HighlighterProps>} */
const Highlight = ({ className, text, highlight, exclude, type }) => {
  return (
    <span
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: renderSanitizedHtml(text, highlight, type, exclude),
      }}
    />
  );
};

Highlight.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  highlight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string.isRequired),
  ]),
  exclude: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.string,
};

Highlight.defaultProps = {
  className: '',
  text: '',
  highlight: [],
  exclude: undefined,
  type: '',
};

export default React.memo(Highlight, isEqual);
